import { QueryMeta, useMutation, UseMutationResult, useQuery } from '@tanstack/react-query'
import { callToAddExportLog, callToGetExportCombo } from '@/services/excel/apis'
import { ExportArea, ExportAudit } from '@/services/excel/excel.types'
import { API_COMMON_CACHE_TIME } from '@/utils/consts'
import { useLocation } from 'react-router-dom'

const PATH = ['excel']
const GET_DOWNLOAD_COMBO = [...PATH, 'GET_DOWNLOAD_COMBO']

/** `meta` — pbo-core 화면은 `{ errorToast: true }` 로 실패 알림을 옛 알럿 대신 새 디자인 알럿(notice.failure)으로 고른다(queryClient.ts — 2.0 안내 기준 '실패=알럿', 옵션 이름 errorToast 는 옛 이름 그대로). */
export const useGetExportCombo = (meta?: QueryMeta) =>
  useQuery({
    meta,
    queryKey: GET_DOWNLOAD_COMBO,
    queryFn: callToGetExportCombo,
    staleTime: API_COMMON_CACHE_TIME,
  })

/**
 * 다운로드 감사로그 — MENU_CD 는 경로 끝(2.0 화면코드), API_NM 은 `{화면코드}[_{탭}]_{영역}_EXPORT`. 영역은 목록 LIST · 고른 행의 상세 DETAIL.
 * 경로 끝이 화면코드가 아닌 화면(`/bl/bl03/:id` 등)은 `menuCode` 를 넘긴다. 탭은 한 탭만 쓰는 다운로드에만 넘긴다.
 */
export const useCompleteExport = (area: ExportArea = 'LIST', audit: ExportAudit = {}): UseMutationResult<unknown, Error, string> => {
  const { pathname } = useLocation()
  const menuCode = audit.menuCode ?? pathname.split('/').findLast(Boolean)?.toUpperCase() ?? ''
  const apiName = [menuCode, audit.tab, area, 'EXPORT'].filter(Boolean).join('_')

  return useMutation({
    mutationFn: (remark: string) => callToAddExportLog({ menuCode, apiName, reason: remark }),
  })
}
